import React, { useEffect, useState } from 'react';
import styles from './client-application-settings-page.module.css';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import HeaderBack from '../../components/HeaderBack/HeaderBack';
import ImageHeaderMenuSelector from '../../components/ImageHeaderMenuSelector/ImageHeaderMenuSelector';
import { getDocBd, getDocumentsByField } from '../../firebase';
import { useDispatch } from 'react-redux';
import { addFilesRedux } from '../../store/slices/filesSlice';
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch';
import SaveButton from '../../components/SaveButton/SaveButton';
import { addAllSettingsApplicationRedux } from '../../store/slices/settingsApplicationSlice';

export default function ClientApplicationSettingsPage() {
  const dispatch = useDispatch();

  // addAllSettingsApplicationRedux

  const [loaderPage, setLoaderPage] = useState(false);

  useEffect(() => {
    setLoaderPage(true);
    const getDocuments = async () => {
      const images = await getDocumentsByField('files', 'fileType', 'image');
      if (images && images.length) {
        dispatch(addFilesRedux(images));
      }
      const settingsApplication = await getDocBd('settingsApplication', 'idSettingsApplication');
      if (settingsApplication) {
        dispatch(addAllSettingsApplicationRedux(settingsApplication));
      } else {
        alert('Не вдалось отримати налаштування програми!!!');
      }
      setLoaderPage(false);
    };
    getDocuments();
  }, []);

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <HeaderBack />
      {/* -------------- /Header ------------------------ */}

      <div className={styles.content_wrapper}>
        <ToggleSwitch />
        <ImageHeaderMenuSelector />
        <SaveButton />
      </div>

      {loaderPage && <LoaderPage />}
    </>
  );
}
